require('./wp-bootstrap')
import Vue from 'vue';
import moment from 'moment';
import mixpanel from 'mixpanel-browser';

// initialize Mixpanel
// here. This bundles into wp-cart.js, which the WP site already loads.
window.MIX_PANEL_TOKEN = 'e48a4d8887915f62d5c278b5186b99c4';
mixpanel.init(window.MIX_PANEL_TOKEN, {
    autocapture: true,
    record_sessions_percent: 100,
});
window.mixpanel = mixpanel;

window.Vue = Vue;
window.moment = moment;
import VueI18n from 'vue-i18n'
import en from '../public/locales/en.json';
import fr from '../public/locales/fr.json';
const i18n = new VueI18n({
    locale: 'en',
    messages: { en, fr }
});


import vSelect from 'vue-select'
const VueInputMask = require('v-mask').default;
Vue.use(VueInputMask);
Vue.use(i18n)

Vue.component('v-select', vSelect)

import helpers from "../resources/assets/js/helpers";
import store from "./store";

Vue.mixin({
    methods:helpers
});

import WPCartComponent from './components/WPCartComponent';
Vue.component('wp-cart', WPCartComponent);

new Vue({
    el: "#wp-cart",
    store,
    i18n
});
